import ApplicationController from '../application_controller'
import { get } from '@rails/request.js'

class LinkEmployeeController extends ApplicationController {
  static targets = ['employeeId', 'linkPath']

  async link () {
    const url = new URL(this.linkPathTarget.href)
    url.searchParams.set('employee_id', this.employeeIdTarget.value)

    await get(url, {
      responseKind: 'turbo-stream'
    })
  }
}

export default LinkEmployeeController
